import { Controller } from "@hotwired/stimulus"
import "./desktop_component.css"

export default class extends Controller {}
